import PropTypes from 'prop-types';
import React from 'react';
import { joinClassNames } from '../../utils';
import { extendedStateType } from '../../types';
import { resolveValue } from '../../utils/fields';
import { NO_STATE } from '../../hooks/useExtendedState';

ReadonlyField.propTypes = {
    keepPosition: PropTypes.bool,
    label: PropTypes.node,
    value: PropTypes.node,
    postfix: PropTypes.node,
    className: PropTypes.string,
    emptyValue: PropTypes.string,
    state: extendedStateType,
};

ReadonlyField.defaultProps = {
    keepPosition: false,
    label: null,
    value: undefined,
    postfix: null,
    className: '',
    emptyValue: '',
    state: NO_STATE,
};

function ReadonlyField(props) {
    const {
        keepPosition,
        label,
        postfix,
        value,
        className,
        emptyValue,
        state,
    } = props;
    const resolvedValue = resolveValue(value, state);
    return (
        <div className={joinClassNames('field', 'readonly', className, keepPosition && 'keep-position')}>
            {label && <span className="field--key">{label}</span>}
            <div className="field--value">
                {((resolvedValue === '' || resolvedValue === null) && emptyValue) ? (
                    <span className="field--value--empty">{emptyValue}</span>
                ) : (
                    <>{resolvedValue}{postfix}</>
                )}
            </div>
        </div>
    );
}
export default ReadonlyField;
